export const isCharWithoutSymbol= /^[A-Za-z0-9@ .,]+(?:[ ][A-Za-z0-9]+)*$/;
export const phoneRegExp = /^\d{10}$/;
export const isFloatNumber = /^\d+(\.\d+)?$/;
export const panNumberRegExp = /^[a-zA-Z0-9]{10}$/;
export const pinCodeRegExp = /^[1-9]{1}[0-9]{5}$/;
export const isNumber =/^\d+$/;